export const FETCH_SHIPMENTS_REQUESTED = 'FETCH_SHIPMENTS_REQUESTED';
export const FETCH_SHIPMENTS_SUCCEEDED = 'FETCH_SHIPMENTS_SUCCEEDED';
export const SORT_SHIPMENTS_REQUESTED = 'SORT_SHIPMENTS_REQUESTED';
export const SORT_SHIPMENTS_SUCCEEDED = 'SORT_SHIPMENTS_SUCCEEDED';
export const UPDATE_SHIPMENT_FILTER = 'UPDATE_SHIPMENT_FILTER';
export const FILTER_SHIPMENT_BY_STATUS = 'FILTER_SHIPMENT_BY_STATUS';
export const SELECT_ALL_VISIBLE_SHIPMENT = 'SELECT_ALL_VISIBLE_SHIPMENT';
export const FETCH_ALL_CUSTOMER_SHIPMENT_SUCCEEDED = 'FETCH_ALL_CUSTOMER_SHIPMENT_SUCCEEDED';


